<template>
<div class="meta-field-filter">
  <div
      :class="['mb-2 filter-row pb-2 pt-1', index === filter.length -1 ? 'last' : '']"
      :key="index + forceReRenderKey" v-for="(item, index) in filter">
    <div class="d-inline-block mr-2 vform-label white">{{ $t('name') }}</div>
    <select
        @change="(evt) => {
          setModifier(index, evt.target.value)
        }"
        class="custom-select form-text-dark mod-selector mr-2"
        :value="filter[index].modifier">
      <option v-if="!['gt', 'lt'].includes(filterModifiers[key])" :key="index2" :value="filterModifiers[key]" v-for="(key, index2) in Object.keys(filterModifiers)">{{ $t(key) }}</option>
    </select>
    <div class="d-inline-block">
      <input type="text" class="form-text form-text-dark" :value="filter[index].val" @input="(evt) => {
        setString(index, evt.target.value)
      }" />
    </div>
    <div @click="removeItem(index)" class="d-inline-block ml-5 lighter clickable"><icon size="1.4" type="fat-square-minus" /></div>
    <div v-if="index !== filter.length - 1" class="or-separator">OR</div>
  </div>
  <div @click="addRow(null)" class="d-inline-block clickable p-1"><icon type="square-plus" /></div>
  <div @click="showImporter = !showImporter" class="clickable lighter">
    {{ $t('filter.importCSV') }}
    <icon v-if="!showImporter" class="ml-1" size="1" type="angle-right" />
    <icon v-if="showImporter" class="ml-1" size="1" type="angle-down" />
  </div>
  <upload-drop-zone
      v-if="showImporter"
      :ref="filterId"
      class="meta-data-upload mt-2"
      :accepted-file-types="'.csv'"
      :auto-update-preview="false"
      :auto-upload="false"
      :downloadable="false"
      :image-editable="true"
      :removable="false"
      asset-type="assembly"
      :form-id="filterId"
      target-type="Asset"
      @data="setColumnNames"
  >
    <div class="mt-3">
      {{ $t("uploadMetaFile") }} – Please only use utf-8 encoded CSV files with one single column per line.
    </div>
  </upload-drop-zone>
</div>
</template>

<script>
import { filterModifiers } from "@/enum";
import Icon from "../Icon";
import {mapState} from "vuex";
import UploadDropZone from "@/components/files/UploadDropZone.vue";

export default {
  name: "StringFilter",
  components: {UploadDropZone, Icon},
  props: {
    filterId: {type: String, default: ''},
    type: {type: String, default: 'filter'}, // filter or merge
  },
  data() {
    return {
      forceReRenderKey: 0,
      filterModifiers: filterModifiers,
      filter: [],
      // this property prevents an endless loop, sending up the newest filter,
      // receiving the newest filter again from parent
      doNotUpdate: false,
      timeout: null,
      showImporter: false
    };
  },
  computed: mapState({exportProfiles: state => state.exportprofile.exportProfiles,}),
  watch: {
    exportProfiles(val) {
      if(val[this.filterId]) {
        this.setFilter();
      }
    },
    filter: {
      deep: true,
      handler() {
        this.$store.dispatch(this.type === 'filter' ? 'overWriteFilterStringArray' : 'overWriteMergeStringArray', {id: this.filterId, value: this.filter});
      }
    },
    type() {
      this.setFilter();
    }
  },
  beforeMount() {
    if(this.exportProfiles[this.filterId]) {
      this.setFilter();
    }
  },
  methods: {
    setColumnNames(string) {
      const decodedFromArrayBuffer = new TextDecoder("utf-8").decode(string);
      const lines = decodedFromArrayBuffer.split(/\r\n|\n/);
      for(let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const values = line.split(',');
        for(let j = 0; j < values.length; j++) {
          const value = values[j].trim();
          if(values[j] === '') {
            continue;
          }
          this.addRow({
            field: "name",
            modifier: "eq",
            val: value
          })
        }
      }
      this.showImporter = false;
    },
    setString(index, value) {
      if(this.timeout) {
        clearTimeout(this.timeout);
      }
      const $this = this;
      this.timeout = setTimeout(() => {
        $this.filter[index].val = value;
      }, 300);
    },
    setFilter() {
      const typer = this.type.charAt(0).toUpperCase() + this.type.slice(1);
      this.filter = this.$store.getters['getExport' + typer +'StringById'](this.filterId);
    },
    setModifier(index, value) {
      this.$set(this.filter[index], "modifier", value);
    },
    addRow(preDefinedField = null) {
      if(preDefinedField) {
        this.filter.push(preDefinedField);
      } else {
        this.filter.push({field: "name", modifier: "eq", val: this.$t('filterSearchSomething')});
      }
      this.doNotUpdate = true;
      this.forceReRenderKey++;
    },
    removeItem(index) {
      this.filter.splice(index, 1);
      this.forceReRenderKey++;
    },
  }
}
</script>

<style scoped>
.meta-field-filter {
  max-width: 800px;
}
.mod-selector {
  width: 200px;
  display: inline-block;
}
.form-text-dark {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}
.filter-row {
  border-bottom: 1px dashed rgba(255,255,255,0.2);
  position: relative;
  padding-bottom: 15px;
  &.last {
    border-bottom: none;
  }
}
.or-separator {
  font-size: 0.7rem;
  text-align: center;
  font-weight: bold;
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  background-color: var(--vform-editor-ui-secondary-color);
  opacity: 0.7;
  border-radius: 3px;
}
.meta-data-upload {
  max-width: 250px;
}
</style>